import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import GlobalCard from "../../components/GlobalCardComponent";
import EnrolledClasses from "./EnrolledClasses";
import ViewAttendanceDetails from "./attendance/ViewAttendanceDetails";
import PerFormanceReport from "./performanceReport/PerFormanceReport";
import AssignmentUI from "./selectedClassDetails/assignment/AssignmentUI";

export default function TestPrepClassroom() {
  const [selectedTab, setSelectedTab] = useState("enrolled");
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={3}>
          <Typography
            fontSize="24px"
            color="#572575"
            sx={{ fontWeight: 400,  }}
          >
            My Classroom
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Card
            sx={{
              boxShadow: "0px 0px 2px 2px #B33B931A", // soft shadow
              padding: "10px",
              borderRadius: "16px",
            }}
          >
            <TabContext value={selectedTab}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    sx: {
                      background: "#572575",
                    },
                  }}
                  sx={{
                    fontSize: "18px !important",
                    "& .MuiTab-root": {
                      fontSize: "18px", // default for all tabs
                     
                      color: "#444444",
                    },
                    "& .Mui-selected": {
                      color: "#572575 !important",
                      // text color when selected
                    },
                  }}
                >
                  <Tab label="Enrolled Classes" value="enrolled" />
                  <Tab label="Assignments" value="assignment" />
                  {/* <Tab label="Attendance" value="attendance" /> */}
                  <Tab label="Reports" value="performancereport" />
                </TabList>
              </Box>
              <TabPanel value="enrolled">
                <EnrolledClasses />
              </TabPanel>
              <TabPanel value="assignment"><AssignmentUI/></TabPanel>
              {/* <TabPanel value="attendance"><ViewAttendanceDetails/></TabPanel> */}
              {/* <TabPanel value="performancereport"><PerFormanceReport/></TabPanel> */}
               <TabPanel value="performancereport">Report</TabPanel>
            </TabContext>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
